export const import_export_finance_locale = {
  TITLE: "Import/Export Finance",
  TABS: {
    EXPORT_FINANCE_DATA: "Export finance data",
    IMPORT_CODA_FILE: "Import CODA file",
  }
};
